import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import usePrintSettings from '../../../../utils/usePrintSettings';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import ProcessHandlingListContext from '../../../../components/ProcessHandlingListContext';
import Button from '@material-ui/core/Button';
import Dialog from '@afosto/app-components-react/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import printShipmentLabels from '../../../../utils/printShipmentLabels/printShipmentLabels';
import translations from './translations';
import { BARCODE_HUB_SETTING_KEY, BARCODE_PRINTER_SETTING_KEY } from '../../../../utils/constants';

const PickFollowUpActionsDialog = ({ isOpen }) => {
  const { handlingList } = useContext(ProcessHandlingListContext);
  const history = useHistory();
  const intl = useIntl();
  const { canPrint, getPrintSettings } = usePrintSettings();
  const shipments = handlingList?.shipments ?? [];

  const handleShipments = () => {
    if (canPrint) {
      const { isConfigured, hubID, printerID } = getPrintSettings(
        BARCODE_HUB_SETTING_KEY,
        BARCODE_PRINTER_SETTING_KEY,
      );

      if (isConfigured) {
        printShipmentLabels(intl, handlingList?.sorting_labels, {
          hubID,
          printerID,
          shouldPoll: false,
        }).catch(() => {});
      }
    }

    history.push('/shipments');
  };

  const handlePacking = () => {
    if (shipments.length === 1) {
      const [shipmentId] = shipments;
      history.push(`/packing/${shipmentId}`);
    } else {
      history.push(`/packing?list_id=${handlingList?.id}`);
    }
  };

  return (
    <Dialog open={isOpen}>
      <DialogTitle>
        <FormattedMessage {...translations.title} />
      </DialogTitle>
      <DialogContent>
        <FormattedMessage {...translations.message} />
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="outlined" onClick={handlePacking}>
          <FormattedMessage {...translations.actions.pack} />
        </Button>
        <Button color="primary" variant="contained" onClick={handleShipments}>
          <FormattedMessage {...translations.actions.shipments} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PickFollowUpActionsDialog.propTypes = {
  isOpen: PropTypes.bool,
};

PickFollowUpActionsDialog.defaultProps = {
  isOpen: false,
};

export default PickFollowUpActionsDialog;
